<template>
  <v-dialog
    persistent
    v-model="showDialog"
    :max-width="dialogWidth"
  >
    <v-card flat class="sign-up">
      <v-row no-gutters>
        <v-col cols="12" sm="6" class="hidden-xs-only">
          <v-img
            :src="image"
            max-height="500px"
            position="center bottom"
          >
            <!-- <p class="credit">Photography by
              <a
                href="https://www.eatbreathecreate.photography"
                target="_blank"
              >Nat Aubry</a>
            </p> -->
          </v-img>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row align="center" no-gutters>
            <v-col cols="12">
              <v-spacer></v-spacer>
              <v-row align="center" justify="end" no-gutters>
                <v-btn
                  icon
                  class="ma-2 text-right"
                  @click="onClose"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-row>
            </v-col>
            <v-col cols="12" class="px-12">
              <h2 class="pb-5 text-center">Join the food loving community</h2>
              <template v-if="!success">
                <p>
                  Sign up and receive Chef Naturelle's recipes, inspirations and latest news
                </p>
                <p>
                  <v-form
                    ref="form"
                    v-model="valid"
                    @submit="onSubmit"
                    @submit.prevent
                    novalidate
                  >
                    <v-row
                      align="center"
                      justify="start"
                      no-gutters
                    >
                      <v-col cols="12">
                        <v-text-field
                          color="black"
                          dense
                          label="First name"
                          v-model="form.name"
                          :disabled="submitting"
                          :rules="rules.name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          color="black"
                          dense
                          label="Email address"
                          v-model="form.email"
                          :disabled="submitting"
                          :rules="rules.email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" class="text-center">
                        <v-btn
                          color="primary"
                          type="submit"
                          :disabled="!valid || submitting"
                        >Subscribe</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </p>
                <p class="privacy">
                  We respect your privacy. For details on how your personal
                  information is used, please read our
                  <a href="/privacy" target="_blank">privacy policy</a>.
                </p>
              </template>
              <template v-else>
                <p class="pa-12 text-center">Thanks for subscribing!</p>
              </template>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  VBtn,
  VCard,
  VCol,
  VDialog,
  VForm,
  VIcon,
  VImg,
  VRow,
  VSpacer,
  VTextField,
} from 'vuetify/lib'

import MailerService from '@/services/MailerService'
import {Validators} from '@/utils/validators'

export default {
  components: {
    VBtn,
    VCard,
    VCol,
    VDialog,
    VForm,
    VIcon,
    VImg,
    VRow,
    VSpacer,
    VTextField,
  },
  computed: {
    dialogWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '500'
        case 'sm': return '950'
        case 'md': return '950'
        case 'lg': return '950'
        case 'xl': return '950'
      }
      return '800'
    },
    showDialog() {
      return this.show
    }
  },
  data: () => ({
    image: require('@/assets/images/sign-up-image.jpg?vuetify-preload'),
    form: {
      form: {
        email: '',
        name: '',
      }
    },
    rules: {
      email: [
        value => Validators.required(value) || 'Email is required.',
        value => Validators.email(value),
      ],
      name: [value => Validators.required(value) || 'Name is required.'],
    },
    submitting: false,
    success: false,
    valid: false,
  }),
  methods: {
    onClose() {
      this.$emit('update:show', false)
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.submitting = true

        MailerService
          .subscribe(this.form.email, this.form.name, ['newsletter'])
          .then(() => {
            this.$refs.form.reset()
            this.submitting = false
            this.success = true
          });
      }
    }
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-up {
  h2 {
    color: rgba(0, 0, 0, 0.87);
    font-family: 'Nanum Myeongjo', serif !important;
    font-size: 30px;
  }

  p {
    font-size: 15px;
  }

  .privacy {
    font-size: 13px;
  }

  .credit {
    color: rgba($color: white, $alpha: .7);
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px 20px;
    margin: 0;

    a {
      color: rgba($color: white, $alpha: .7);
    }
  }
}
</style>
